"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentTheme = void 0;
exports.currentTheme = (process.env.GATSBY_CARITAS_THEME || 'caritas');
